import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { ServerError } from '@app/error/ServerError';

export interface IBulkAssignClientValues {
  accounts: string[];
  client: number;
  manager: number;
}

export const fetch = async (data: IBulkAssignClientValues): Promise<void> => {
  const clientId = typeof data.client === 'number' ? data.client : Number(data.client);
  const managerId = typeof data.manager === 'number' ? data.manager : Number(data.manager);

  await api.patch<void>(`${PANEl_BASE_URL}/accounts/accounts/bulk_update_client/`, {
    accounts: data.accounts,
    client: clientId,
    manager: managerId,
  });
};

export const useBulkAssignClient = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
